'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function TicketComponent($http, AppConstants) {
	'ngInject';

	var service = {
		fetchSeat: fetchSeat,
		createTicket: createTicket,
		updateTicket: updateTicket,
		deleteTicket: deleteTicket,
		reviewTicket: reviewTicket,
		showTicket: showTicket
	};

	var seat = {};

	return service;

	function fetchSeat(id) {
		return $http.get(AppConstants.apiUrl + '/seats/' + id, {
			'params': {
				'with': 'ticket,ticket.discount.translation'
			}
		}).then(setSeat)['catch'](failedRequest);
	}

	function setSeat(res) {
		seat = res.data.data;

		return seat;
	}

	function createTicket(params) {
		params.is_public = params.is_public ? 1 : 0;
		return $http.post(AppConstants.apiUrl + '/seats', params).then(successRequest)['catch'](failedRequest);
	}

	function updateTicket(id, params) {
		params.is_public = 1;
		return $http.put(AppConstants.apiUrl + '/seats/' + id, params).then(successRequest)['catch'](failedRequest);
	}

	function reviewTicket(id, params) {
		return $http.put(AppConstants.apiUrl + '/tickets/' + id, params).then(successRequest)['catch'](failedRequest);
	}

	function deleteTicket(id) {
		return $http['delete'](AppConstants.apiUrl + '/tickets/' + id).then(successRequest)['catch'](failedRequest);
	}

	/** */
	function showTicket(id) {
		return $http.get(AppConstants.apiUrl + '/tickets/' + id).then(successRequest)['catch'](failedRequest);
	}

	function successRequest(response) {
		return response;
	}

	function failedRequest(requestError) {
		console.log(requestError);

		return requestError;
	}
}

exports['default'] = TicketComponent;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/ticket/ticket.service.js
 **/